import { DotsButtonProps } from './DotsButtonProps'

export const defaultProps: DotsButtonProps = {
  opened: false,
  onClick: undefined
}
